export default "__VITE_ASSET__47161396__"